module.exports = __webpack_public_path__ + "static/media/search.179f5b14.svg";